import { querySearch } from '@/api/competitor'

export class CoreBaseUtile {
  $querySearch(params) {
    return querySearch(params)
  }
}

export const coreBaseUtile = new CoreBaseUtile()
